export default "__VITE_ASSET__BVqXvs25__";